module.exports = __webpack_public_path__ + "img/blue_026.69f7de40.png";